/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * renewedToday: a renewal completed today and Junifer has not synced yet. renewalPending: a renewal is in progress or parked for an agent. noRenewableAgreements: no agreement is inside its renewal window. accountOnPayg: the account has a Pay As You Go meter, so quotes and submit would refuse it
 */
export type RenewalIneligibilityReason =
  (typeof RenewalIneligibilityReason)[keyof typeof RenewalIneligibilityReason]

export const RenewalIneligibilityReason = {
  renewedToday: "renewedToday",
  renewalPending: "renewalPending",
  noRenewableAgreements: "noRenewableAgreements",
  accountOnPayg: "accountOnPayg",
} as const
